import { motion } from "framer-motion";
import { Sparkles, Wind, HeartHandshake } from "lucide-react";
import { Reveal, Label } from "./primitives";

const SERVICES = [
  {
    id: "tarot",
    n: "01",
    title: "Tarot Readings",
    icon: Sparkles,
    desc: "Personal, intuitive readings that decode the questions of love, career and purpose — offering clarity where there is confusion.",
    img: "https://images.unsplash.com/photo-1671377914227-397fa571a7e5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwzfHx0YXJvdCUyMGNhcmRzJTIwZGFyayUyMGdvbGR8ZW58MHx8fHwxNzg2MDk4OTM1fDA&ixlib=rb-4.1.0&w=1000&q=68&auto=format",
    span: "md:col-span-7",
  },
  {
    id: "cleansing",
    n: "02",
    title: "Energy Cleansing",
    icon: Wind,
    desc: "Clearing stagnant, heavy energy from your space and self using crystals, smoke and sound.",
    img: "https://images.unsplash.com/photo-1567113463224-37cf03ba4577?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwyfHxjcnlzdGFsJTIwZW5lcmd5JTIwaGVhbGluZyUyMG1vb2R5fGVufDB8fHx8MTc4NjA5ODkzNXww&ixlib=rb-4.1.0&w=1000&q=68&auto=format",
    span: "md:col-span-5",
  },
  {
    id: "healing",
    n: "03",
    title: "Energy Healing",
    icon: HeartHandshake,
    desc: "Gentle, restorative healing sessions to rebalance your chakras and reconnect you with a calm, grounded centre.",
    img: "https://images.unsplash.com/photo-1521133573892-e44906baee46?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwxfHxjcnlzdGFsJTIwZW5lcmd5JTIwaGVhbGluZyUyMG1vb2R5fGVufDB8fHx8MTc4NjA5ODkzNXww&ixlib=rb-4.1.0&w=1400&q=68&auto=format",
    span: "md:col-span-12",
  },
];

const Card = ({ s, delay }) => {
  const Icon = s.icon;
  return (
    <Reveal delay={delay} className={s.span}>
      <div
        data-testid={`service-card-${s.id}`}
        className="group relative overflow-hidden rounded-2xl border border-[#2A1F3D] bg-[#130C1E] h-full min-h-[340px] p-8 md:p-10 flex flex-col justify-between"
      >
        <img
          src={s.img}
          alt=""
          aria-hidden="true"
          loading="lazy"
          decoding="async"
          className="absolute inset-0 z-0 w-full h-full object-cover opacity-25 group-hover:opacity-40 group-hover:scale-105 transition-all duration-700"
        />
        <div className="absolute inset-0 z-0 bg-gradient-to-t from-[#07040D] via-[#130C1E]/70 to-transparent" />

        <div className="relative z-10 flex items-center justify-between">
          <span className="font-serif-display text-[#D4AF37]/60 text-2xl">
            {s.n}
          </span>
          <Icon className="w-6 h-6 text-[#D4AF37]" strokeWidth={1.3} />
        </div>

        <div className="relative z-10 mt-auto max-w-md">
          <h3 className="font-serif-display text-3xl sm:text-4xl text-[#EAE0D5] font-light tracking-tight">
            {s.title}
          </h3>
          <p className="mt-4 text-[#A89FA8] text-sm sm:text-base leading-relaxed">
            {s.desc}
          </p>
        </div>
      </div>
    </Reveal>
  );
};

export const Services = () => (
  <section
    id="services"
    data-testid="services-section"
    className="relative py-24 md:py-32 px-6 md:px-10"
  >
    <div className="aura w-[500px] h-[500px] -top-40 right-0" />
    <div className="max-w-[1400px] mx-auto relative">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-16">
        <Reveal>
          <Label>The Offerings</Label>
          <h2 className="mt-5 font-serif-display font-light text-4xl sm:text-6xl text-[#EAE0D5] tracking-tight leading-none">
            Rituals for the <br />
            <span className="italic text-[#D4AF37]">soul & spirit</span>
          </h2>
        </Reveal>
        <Reveal delay={0.15}>
          <p className="max-w-sm text-[#A89FA8] text-sm leading-relaxed">
            Each session is held as sacred space — unhurried, intuitive and
            tailored entirely to where you are on your journey.
          </p>
        </Reveal>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-12 gap-6">
        {SERVICES.map((s, i) => (
          <Card key={s.id} s={s} delay={i * 0.1} />
        ))}
      </div>
    </div>
  </section>
);
